import { Allocation, Identifiable, Task } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedAllocation } from "../linkers/types";
import { mapError } from "../utils/mapError";

function saveAllocation(httpClient: HttpClient) {
  return (task: Identifiable<Task>, allocation: Allocation) =>
    httpClient
      .sendHttpRequest<LinkedAllocation>({
        endpoint: `/allocations`,
        method: HttpMethods.POST,
        data: {
          ...allocation,
          task: `/tasks/${task.uuid}`,
          resource: `/resources/${allocation.resource.uuid}`,
        },
      })
      .then((savedAllocation) => ({
        ...savedAllocation,
        resource: allocation.resource,
      }))
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            duplicateAllocation: "duplicateAllocation",
          }),
        ),
      );
}

export { saveAllocation };
